import HttpUtil from "@/utils/HttpUtil";

export default {
    //获取类型列表
    getTypeList(enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/dictionary/getTypeList",{
                enable: enable !== undefined && enable !== null?enable: ""
            }).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("获取类型列表异常",e)
                reject(e);
            })
        });
    },
    //获取值列表
    getValueList(dictTypeId){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/dictionary/getValueList",{
                dictTypeId
            }).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("获取值列表异常",e)
                reject(e);
            })
        });
    },
    //创建类型
    createType(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/createType",params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("创建字典类型异常",e)
                reject(e);
            })
        });
    },
    //修改类型
    updateType(id,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/updateType/"+id,params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("修改字典类型异常",e)
                reject(e);
            })
        });
    },
    //创建值
    createValue(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/createValue",params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("创建字典值异常",e)
                reject(e);
            })
        });
    },
    //更新字典值
    updateValue(id,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/updateValue/"+id,params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("更新字典值异常",e)
                reject(e);
            })
        });
    },
    //字典类型切换启用状态
    switchTypeEnable(id,enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/switchTypeEnable/"+id,{
                enable
            }).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("更新字典类型异常",e);
                reject(e);
            })
        });
    },
    //字典值切换启用状态
    switchValueEnable(id,enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/switchValueEnable/"+id,{
                enable
            }).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("更新字典值异常",e);
                reject(e);
            })
        });
    },
    //删除类型
    deleteType(id){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/deleteType/"+id,{}).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("删除字典类型异常",e);
                reject(e);
            })
        });
    },
    deleteValue(id){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/dictionary/deleteValue/"+id,{}).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("删除字典值异常",e);
                reject(e);
            })
        });
    }
}
